// extracted by mini-css-extract-plugin
export default {"button":"eYt2Rf","disabled":"LB6aAT","size-32":"k_IvVm","size-64":"rT6vcz","size-72":"bTk8vm"};